import {Button} from '@dropbox/dig-components/buttons';
import {Truncate} from '@dropbox/dig-components/truncate';
import {Box, Stack} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {ArrowLeftLine} from '@dropbox/dig-icons/assets';
import {Employee} from 'client';
import {t} from 'i18next';
import {useEffect, useState} from 'react';

import {RowPreview} from './RowPreview';
import {SearchRow} from './searchRows';

const titleOf = (row: SearchRow) =>
  row.kind === 'person'
    ? row.person.name
    : row.kind === 'meeting'
      ? row.meeting.title
      : row.kind === 'team'
        ? (row.team.name ?? t('team'))
        : row.kind === 'workstream'
          ? row.workstream.name
          : row.kind === 'knowledge'
            ? row.result.title
            : row.kind === 'news'
              ? row.post.title
              : row.question;

/**
 * The right pane: `root`, and a trail of things clicked inside it. Clicking a
 * person or team in the pane opens them here, with a link back, so walking the
 * org never leaves the box.
 */
export const Panel = ({
  root,
  onOpenPerson,
  onGo,
  embedded = false,
}: {
  root: SearchRow;
  onOpenPerson: (person: Employee) => void;
  /** Go to a row (open an article). */
  onGo: (row: SearchRow) => void;
  /** The root's title is already on screen (the question in the field): skip it. */
  embedded?: boolean;
}) => {
  const [trail, setTrail] = useState<SearchRow[]>([]);
  useEffect(() => setTrail([]), [root.id]);

  const current = trail[trail.length - 1] ?? root;
  const previous = trail.length > 1 ? trail[trail.length - 2] : trail.length === 1 ? root : null;

  return (
    <Stack gap="12">
      {previous && (
        <Box>
          <Button
            variant="transparent"
            size="small"
            withIconStart={<UIIcon src={ArrowLeftLine} />}
            onClick={() => setTrail((rows) => rows.slice(0, -1))}
          >
            <Truncate maxWidth={360}>{titleOf(previous)}</Truncate>
          </Button>
        </Box>
      )}
      <RowPreview
        row={current}
        onOpenPerson={onOpenPerson}
        onGo={onGo}
        onSelect={(row) => setTrail((rows) => [...rows, row])}
        embedded={embedded && trail.length === 0}
      />
    </Stack>
  );
};
